import { render } from "./KingdomEventNotification2.vue?vue&type=template&id=362ed8df"
import script from "./KingdomEventNotification2.vue?vue&type=script&lang=js"
export * from "./KingdomEventNotification2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/KingdomEventNotification2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "362ed8df"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('362ed8df', __exports__)) {
    api.reload('362ed8df', __exports__)
  }
  
  module.hot.accept("./KingdomEventNotification2.vue?vue&type=template&id=362ed8df", () => {
    api.rerender('362ed8df', render)
  })

}


export default __exports__